export const reviewInsurancePageTranslations = {
  en: {
    reviewInsurancePage: {
      addAnotherInsurance: 'Add another insurance',
      confirmInsurance: 'Confirm insurance',
      removeInsuranceModalBody:
        'Your provider will need to review this change with you at your appointment. Would you like to continue with this removal?',
      removeInsuranceModalConfirm: 'Yes, flag for removal',
      removeInsuranceModalTitle: 'Remove this card?',
      title:
        'Review the insurance that we have on file, and let us know how you would like to continue.',
      withoutAddingInsurance:
        'Without adding insurance you may be fully responsible for your medical bill out-of-pocket.',
      invalidInsurancesModalTitle: 'Invalid card information',
      invalidInsurancesModalBody:
        'There is invalid or missing card information highlighted in red. Please edit or remove the highlighted card(s) before continuing.',
    },
  },
  es: {
    reviewInsurancePage: {
      addAnotherInsurance: 'Agregar otro seguro',
      confirmInsurance: 'Confirmar seguro',
      removeInsuranceModalBody:
        'Su proveedor deberá revisar este cambio con usted en su cita. ¿Le gustaría continuar con esta eliminación?',
      removeInsuranceModalConfirm: 'Sí, marcar para eliminación',
      removeInsuranceModalTitle: 'Eliminar esta tarjeta?',
      title:
        'Revise el seguro que tenemos registrado y díganos cómo le gustaría continuar.',
      withoutAddingInsurance:
        'Sin agregar un seguro, usted puede ser totalmente responsable de pagar su factura médica de su bolsillo.',
    },
  },
  ja: {
    reviewInsurancePage: {
      addAnotherInsurance: '別の保険を追加する',
      confirmInsurance: '保険を確認する',
      title:
        '弊社に登録されている保険をご確認のうえ、どのように手続きを進めたいかをお知らせください。',
      withoutAddingInsurance:
        '保険を追加しない場合、医療費は全額自己負担となる可能性があります。',
    },
  },
  bn: {
    reviewInsurancePage: {
      addAnotherInsurance: 'অন্য একটি বীমা যোগ করুন',
      confirmInsurance: 'বীমা নিশ্চিত করুন',
      title:
        'আমাদের ফাইলে থাকা বীমাটি পর্যালোচনা করুন এবং আপনি কীভাবে চালিয়ে যেতে চান, তা জানান।',
      withoutAddingInsurance:
        'বীমা যোগ না করলে, আপনি নিজের চিকিৎসা বিল পরিশোধের ক্ষেত্রে সম্পূর্ণরূপে দায়ী থাকতে পারেন।',
    },
  },
  pt: {
    reviewInsurancePage: {
      addAnotherInsurance: 'Adicionar outro seguro',
      confirmInsurance: 'Confirmar o seguro',
      removeInsuranceModalBody:
        'Su proveedor deberá revisar este cambio con usted en su cita. ¿Le gustaría continuar con esta eliminación?',
      title:
        'Revise o seguro que temos no nosso arquivo e diga-nos como você gostaria de continuar.',
      withoutAddingInsurance:
        'Sem adicionar um seguro, você pode ser totalmente responsável pelas suas despesas médicas.',
    },
  },
  ro: {
    reviewInsurancePage: {
      addAnotherInsurance: 'Adaugă o altă asigurare',
      confirmInsurance: 'Confirmă asigurarea',
      title:
        'Examinați asigurarea pe care o avem în dosar și spuneți-ne cum doriți să continuați.',
      withoutAddingInsurance:
        'Fără să adăugați asigurare, puteți fi pe deplin responsabil pentru factura medicală din buzunar.',
    },
  },
  ko: {
    reviewInsurancePage: {
      addAnotherInsurance: '다른 보험 추가',
      confirmInsurance: '보험 확인',
      title:
        '당원 파일에 있는 보험을 검토한 후 계속 진행할지 여부를 알려주십시오.',
      withoutAddingInsurance:
        '보험을 추가하지 않으면 의료 고지서 본인 부담 비용에 대해 전적으로 본인이 책임져야 할 수 있습니다.',
    },
  },
  zh: {
    reviewInsurancePage: {
      addAnotherInsurance: '添加其他保险',
      confirmInsurance: '确认保险',
      title: '查看我们存档的保险，并告诉我们您希望如何继续。',
      withoutAddingInsurance:
        '如果不添加保险，您可能会全额支付医疗费用自付额。',
    },
  },
};
